export enum OENLockProfileType {
  // modify locking profiles
  PARTIAL_LOCK,
  PARTIAL_ACTIVE_LOCK,
  FULL_LOCK,
  LOOP_ACTIVE_LOCK, //
  LOOP_PASSIVE_LOCK,
  NO_ROOT_ACTIVE_LEG_LOCK, // Strategy node (not root) on which modify was invoked locking, when root was filled or terminal
  // Modify-info locking profiles
  MODIFY_INFO_ACTIVE_LOCK,
  MODIFY_INFO_PASSIVE_LOCK,
  MODIFY_INFO_TERMINAL_LOCK,
  // Amend Markup
  AMEND_MARKUP_LOCK,
}
